import { RemoteCreateApiKey } from 'data/usecases/api-keys';
import { makeApiUrlApiKeys } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateApiKey = (): RemoteCreateApiKey => {
  return new RemoteCreateApiKey(makeApiUrlApiKeys(), makeAxiosHttpClient());
};
